// The dashboard/admin-panel app is a separate container (Telecalling frontend)
// living on its own subdomain. Auth cookies are shared via the parent domain
// (see utils/tokenStorage.js), so a full-page redirect here carries the
// logged-in session over automatically — no token needs to be passed in the URL.
const BASE_URL = process.env.REACT_APP_DASHBOARD_URL;

export const getDashboardUrl = (path = '/dashboard/overview') => {
  if (!BASE_URL) {
    throw new Error('REACT_APP_DASHBOARD_URL environment variable is required');
  }
  return `${BASE_URL.replace(/\/$/, '')}${path}`;
};
